import { render, staticRenderFns } from "./compMT.vue?vue&type=template&id=13369807&scoped=true"
import script from "./compMT.vue?vue&type=script&lang=js"
export * from "./compMT.vue?vue&type=script&lang=js"
import style0 from "./compMT.vue?vue&type=style&index=0&id=13369807&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13369807",
  null
  
)

export default component.exports